import { Loader, Stack } from "components";

const CheckoutLoader = () => (
  <Stack
    placeContent="center"
    style={{
      gap: "12px",
      padding: "14px 16px",
      margin: "0 -16px",
      background: "#e3f2fd",
    }}
  >
    <Loader overlay={false} />
  </Stack>
);

export default CheckoutLoader;
